import { DivideIcon as LucideIcon } from 'lucide-react';

interface ContactInfoItem {
  icon: LucideIcon;
  title: string;
  content: string;
}

interface ContactInfoProps {
  items: ContactInfoItem[];
  className?: string;
}

export function ContactInfo({ items, className }: ContactInfoProps) {
  return (
    <div className={`space-y-6 ${className}`}>
      {items.map((item, index) => (
        <div key={index} className="flex items-start space-x-4">
          <div className="flex-shrink-0">
            <div className="w-12 h-12 bg-blue-100 rounded-lg flex items-center justify-center">
              <item.icon className="h-6 w-6 text-blue-600" />
            </div>
          </div>
          <div>
            <h3 className="font-semibold text-gray-900 mb-1">
              {item.title}
            </h3>
            <p className="text-gray-600 whitespace-pre-line">
              {item.content}
            </p>
          </div>
        </div>
      ))}
    </div>
  );
}